// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LevelPage from "./pages/level/LevelPage";
import Pressure from "./pages/Pressure/Pressure.js";
import Flow from "./pages/Flow/Flow.js";
import Careers from "./pages/Careers/Careers.js"; 
import Contact from "./pages/Contact/Contact.js"
import Solution from "./pages/Solution/Solution";
import Industry from "./pages/Industry/Industry.js";
import Temperature from "./pages/Temperature/Temperature.js";
import AnalyticalPage from "./pages/Analytical/Analytical.js";
import IndicatorPage from "./pages/Indicator/Indicator.js";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/level" element={<LevelPage />} />
         <Route path="/Pressure" element={<Pressure />} />
         <Route path="/Flow" element={<Flow />} />
         <Route path="/temperature" element={<Temperature />} />
         <Route path="/careers" element={<Careers />} />
         <Route path="/contact" element={<Contact />} />
         <Route path="/solutions" element={<Solution />} />
         <Route path="/industry" element={<Industry />} />
         <Route path="/analytical" element={<AnalyticalPage />} />
         <Route path="/indicator" element={<IndicatorPage />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
